import { render, staticRenderFns } from "./BlockType22.vue?vue&type=template&id=2ed079db&scoped=true&"
import script from "./BlockType22.vue?vue&type=script&lang=ts&"
export * from "./BlockType22.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType22.vue?vue&type=style&index=0&id=2ed079db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed079db",
  null
  
)

export default component.exports